import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center text-red-700 px-4">
      <h1 className="text-6xl font-bold">404</h1>
      <p className="text-xl mt-2">Page not found.</p>
      <p className="text-md mt-1 mb-4">The page you're looking for doesn't exist or has been moved.</p>
      <Link to="/home" className="px-4 py-2 bg-red-700 text-white rounded hover:bg-red-800 transition">
        Go back to Home
      </Link>
    </div>
  );
};

export default NotFound;
